<template>
  <div>
    <div class="bg-image">
      <page-header>
        <uiv-carousel ref="carousel" :indicators="indicators" :controls="false" :interval="interval">
          <uiv-slide v-for="(slide, index) in slides" :key="index">
            <div class="text-center" style="width: 100%; min-height: 250px">
              <h1 class="text-center center-block _margin-bottom-30"
                style="max-width: 700px; margin: auto; color: #fff">
                {{ slide.title }}
              </h1>

              <div v-if="slide.type">
                <uiv-btn type="primary" @click="onExplore(slide.type, slide.buttonName)"
                  v-html="slide.buttonName"></uiv-btn>
              </div>
              <div v-else>
                <uiv-btn class="_margin-top-10" type="primary" @click="onExplore(slide.button.type, slide.button.name)"
                  v-html="slide.button.name" style="margin-right: 20px"></uiv-btn>

                <uiv-btn class="_margin-top-10" type="primary"
                  @click="onExplore(slide.button2.type, slide.button2.name)" v-html="slide.button2.name"></uiv-btn>
              </div>
            </div>
          </uiv-slide>
        </uiv-carousel>
      </page-header>
    </div>

    <div class="page-section">
      <div class="container">
        <h4>Explore Smart Energy</h4>

        <div class="row">
          <div class="col-sm-6 col-md-4 _margin-bottom-20">
            <div class="card">
              <img class="img-responsive" src="../../assets/home/solar.png" />

              <div>
                <p>
                  From energy independence to long-term savings. Learn about the
                  energy benefits and the cost of Solar & Battery storage for
                  your home.
                </p>
              </div>

              <div class="card-footer">
                <uiv-btn block type="primary" @click="onExplore('solar', 'Explore Home Solar & Battery')">
                  Explore Home Solar & Battery</uiv-btn>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-4 _margin-bottom-20">
            <div class="card">
              <img class="img-responsive" src="../../assets/home/ev.png" />
              <div>
                <p>
                  Discover how adopting an Electric Vehicle (EV) can save you on
                  fuel costs. Compare charging costs with your traditional
                  petrol or diesel vehicle and explore the best energy deals for
                  maximum savings.
                </p>
              </div>

              <div class="card-footer">
                <uiv-btn block type="primary" @click="onExplore('evCompare', 'Compare EV Charging vs.Fuel Costs')"
                  class="_margin-bottom-20">
                  Compare EV Charging vs. Fuel Costs
                </uiv-btn>

                <uiv-btn block type="primary" @click="onExplore('evOnly', 'See the Best EV Energy Deal')">
                  See the Best EV Energy Deal
                </uiv-btn>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-4 _margin-bottom-20">
            <div class="card">
              <img class="img-responsive" src="../../assets/home/ashp.png" />
              <div>
                <p>
                  Air Source Heat Pumps provide superior efficiency, lower
                  carbon emissions, and long-term cost savings compared to
                  traditional heating systems. Discover if a heat pump is the
                  right choice for your home.
                </p>
              </div>

              <div class="card-footer">
                <uiv-btn block type="primary" @click="onExplore('ashp', 'Explore Heat Pump')">
                  Explore Heat Pump
                </uiv-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import YourHome from '@/components/current-tariff/YourHome';
import PageHeader from '@/components/page-header/PageHeader';

import { mapState } from 'vuex';

export default {
  name: 'Home',
  data() {
    return {
      interval: 5000,
      indicators: true,
      slides: [
        {
          title: 'Explore the benefits of Smarter Energy in your home',
          buttonName: 'Explore Home Solar & Battery',
          type: 'solar'
        },
        {
          title: 'Make the most of the sunshine with Solar & Battery',
          buttonName: 'Explore Home Solar & Battery',
          type: 'solar'
        },
        {
          title: 'Getting from A to B with the power of Electricity',
          button: {
            name: 'Compare EV Charging vs. Fuel Costs',
            type: 'evCompare'
          },
          button2: {
            name: 'See the Best EV Energy Deal',
            type: 'evOnly'
          }
        },
        {
          title: 'Cleaner, more efficient and smarter ways to heat your home',
          buttonName: 'Explore Heat Pump',
          type: 'ashp'
        }
      ]
    };
  },
  async mounted() {
    this.$store.commit('quote/resetState');
    this.$store.commit('lookups/resetState');
    this.$store.commit('storage/reset');

    this.$store.dispatch('tracing/addAction', {
      name: 'Action',
      value: 'Viewed'
    });
    await this.$store.dispatch('tracing/saveActions');
  },
  computed: {
    ...mapState({
      quote: ({ session }) => session.quote_journey_session,
      appSettings: ({ app_settings }) => app_settings
    })
  },
  methods: {
    onExplore(type, buttonName) {
      if (type == 'all') {
        this.quote.evCompare = true;
        this.quote.evOnly = false;
        this.quote.ashp = true;
        this.quote.solar = true;
      } else {
        this.quote.evCompare = false;
        this.quote.evOnly = false;
        this.quote.ashp = false;
        this.quote.solar = false;
        this.quote[type] = true;
      }

      this.$store.dispatch('session/setItem', {
        key: 'quote_journey_session',
        value: this.quote
      });

      this.$store.dispatch('tracing/addAction', { name: 'Action', value: buttonName });
      this.$store.dispatch('tracing/saveActions');

      this.$router.push({ name: 'currentTariff' });
    }
  },
  components: {
    YourHome,
    PageHeader
  }
};
</script>

<style lang="scss" scoped>
.page-section {
  background-color: rgba(0, 45, 204, 0.28);
  padding-top: 25px;
  padding-bottom: 25px;
  margin-bottom: -40px;
}

.card {
  position: relative;

  .card-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 20px;
  }

  @media (min-width: 768px) {
    min-height: 655px;
  }

  @media (max-width: 767px) {
    img {
      width: 60%;
      margin: auto;
    }

    .card-footer {
      position: relative;
      bottom: auto;
      left: auto;
      padding: 0;
    }
  }
}

.bg-image {
  background: url('../../assets/home/header.png') no-repeat;
  background-size: cover;
}
</style>
